import { hasPermissionByRouteList } from '../core/config/Permission';
import { Route } from '../core/utils/RouteMixins';
import BemVindo from '../pages/BemVindo';
import { EmptyPage } from '../pages/EmptyPage';
import analiseMetodologicaRoutes from '../pages/sei/analiseMetodologica/PageRoutes';
import analiseNegocialRoutes from '../pages/sei/analiseNegocial/PageRoutes';
import historicoIndicadorRoutes from '../pages/sei/historicoIndicador/PageRoutes';
import indicadorRoutes from '../pages/sei/indicador/PageRoutes';
import indicadorSolicitacoesRoutes from '../pages/sei/indicadorSolicitacoes/PageRoutes';
import metasResultadosRoutes from '../pages/sei/metasResultados/PageRoutes';
import propostaIndicadorRoutes from '../pages/sei/propostaIndicador/PageRoutes';
import statusPropostaRoutes from '../pages/sei/statusProposta/PageRoutes';
import analisePropostaMetaRoutes from '../pages/sei/analisePropostaMeta/PageRoutes';

const Menu = () => {
    const retorno = [
        Route(['Pagina Inicial', 'pi pi-home'], '/', BemVindo),
        Route(null, '/EmptyPage', EmptyPage),
        {
            label: 'Definição/Alteração de Indicadores',
            icon: 'pi pi-list',
            items: [
                ...propostaIndicadorRoutes,
                ...analiseNegocialRoutes,
                ...analiseMetodologicaRoutes,
                ...indicadorSolicitacoesRoutes,
                ...analisePropostaMetaRoutes,
            ],
        },
        ...statusPropostaRoutes,
        ...indicadorRoutes,
        ...metasResultadosRoutes,
        ...historicoIndicadorRoutes,
    ];

    return hasPermissionByRouteList(retorno);
};

export default Menu;
